import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import moment from 'moment'
import './fontawesome'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'

import 'element-ui/lib/theme-chalk/index.css'
import './theme/element/index.css'
import './assets/css/tailwind.css'
import './assets/css/main.css'

Vue.use(ElementUI, { locale })

Vue.config.productionTip = false

const accessToken = localStorage.getItem('access_token')

if (accessToken != null) {
  axios.defaults.headers.common['Authorization'] = "bearer " + accessToken
}

axios.defaults.baseURL = BASE_API_URL

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD-MMM-YYYY')
  }
})

Vue.filter('formatDateTime', function(value) {
  if (value) {
    return moment(String(value)).format('DD-MMM-YYYY HH:mm:ss')
  }
})

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')


